<template>
    <div v-if="loading" class="loading-overlay">
        <div class="spinner"></div>
        Loading...
    </div>
    <div class="modal show d-block" id="productModal" tabindex="-1" aria-labelledby="productModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="d-flex modal-header justify-space-between">
                    <h5 class="modal-title" id="productModalLabel">Requested Parts</h5>
                    <v-btn icon="$close" variant="text" @click="closeScreen"></v-btn>

                </div>
                <div class="modal-body">
                    <v-card class="mt-1">
                        <v-card-text>
                            <v-window v-model="tab">
                                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" single-line
                                    variant="outlined" hide-details></v-text-field>
                                <v-data-table :custom-filter="filterOnlyCapsText" :headers="headers" :items="items"
                                    :search="search" item-value="name" class="text-h6">

                                    <template #[`item`]="{ item }">
                                        <tr class="data-table-row" @click="sendData(item.INVO_NO, item.CONT_NO)">
                                            <td class="text-start">{{
                                                item.INVO_NO }}</td>
                                            <td class="text-end">{{ item.CONT_NO }}</td>
                                            
                                            <!-- <td v-if="index === 0" class="text-end" :rowspan="item.ITMNO.length">
                                                <router-link :to="`/scanTransaction/${this.offsetNo}/${item.CONT_NO}`">
                                                    <v-list-item-title>
                                                        <v-icon icon="mdi-barcode-scan"></v-icon>

                                                    </v-list-item-title>
                                                </router-link>
                                            </td> -->
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-window>
                        </v-card-text>
                    </v-card>
                </div>

            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    props: ['products', 'offsetNo'],
    data() {
        return {
            loading: false,
            search: '',
            tab: null,
            headers: [
                {
                    title: 'Invo No',
                    align: 'start',
                    key: 'INVO_NO'
                },
                {
                    title: 'Cont No',
                    align: 'end',
                    key: 'CONT_NO'
                },

            ],
            addedProducts: [],
            items: [],
        };
    },
    mounted() {
        this.loading = true;
        this.items = Object.values(this.products);
        this.loading = false;
    },
    computed: {
        // filteredProducts() {
        //     // for (let item of this.products) {
        //     //     this.items.push({
        //     //         'CONT_NO': item.CONT_NO
        //     //     })
        //     // }
        //     return this.products;
        // }
    },
    methods: {
        async sendData(invoNo, contNo) {
            this.loading = true;
            try {
                let tempList = {
                    'INVO_NO': invoNo,
                    'CONT_NO': contNo,
                }
                this.$emit('submit-products', tempList);
                this.$emit('close-modal');
            } catch (err) {
                //console.error('Sending error', err);
            }
            this.loading = false;
        },
        closeScreen() {
            this.$emit('close-modal');
        }
    }
}
</script>
  
<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
}

.spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid black;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

.modal-sm {
    max-width: 800px;
}
.data-table-row:hover {
    background-color: #f5f5f5;
    /* 마우스 오버 시 배경색 변경 */
    cursor: pointer;
}

.modal-table td,
.modal-table tr {
    text-align: center;
}

.modal-table td input {
    margin: 0 auto;
}

.box-qty-input {
    max-width: 150px;

}

.box-input-control {
    width: 100%;
    text-align: center;
}
</style>